export type IMaintenance = {
  _id?: string;
  name: string;
  renterId: string;
  vehicleId: string;
  licensePlate: string;
  waitingTicket: number;
  mechanic: string;
  reason?: string;
  chassi: string;
  model: string;
  color: string;
  whatsapp: string;
  diagnosis?: boolean;
  registers: MaintenanceDocuments[];
  createdAt: Date;
  updatedAt: Date;
  status: MAINTENANCE_STATUS;
  budgetMaintenance: ProductOrServiceType;
  typeOfEvent: string;
  observations: observations[];
  odometer: string;
  odometerLocavibe: string;
  typePlanRenter: string;
  forecastMaintenance?: {
    dateNextMaintenance: Date;
    odometer: number;
  };
  partnerCompanyName: string;
  chargeMaintenance?: {
    confirmed: boolean;
    charged: boolean;
    wasInsertedMaintenanceCharges: boolean;
    contested?: boolean;
  };
  typeMaintenance: "Interna" | "Externa" | "";
  autoService: boolean;
  companyId: string;
  contestation?: IContestation;
  collision?: boolean;
};

export type IContestationResposta = {
  date: Date;
  description: string;
};

export type IContestation = {
  date: Date;
  message: string;
  status: string;
  respostas: IContestationResposta[];
  budgetMaintenance: ProductOrServiceType;
  companyId: string;
};

export type MaintenanceType = {
  _id: string;
  licensePlate: string;
  name: string;
  pendencies: PendencyType[];
  status: MAINTENANCE_STATUS;
  updatedAt: string;
  createdAt: string;
};

export type PendencyType = {
  key: string;
  message: string;
  entityErrors: [
    {
      message: string;
      path: string[];
    }
  ];
};

export type observations = {
  text: string;
  date: string;
  author: string;
};

export enum MAINTENANCE_STATUS {
  Screening = "screening",
  Pending = "pending",
  UNDER_REVIEW = "under_review",
  Finalize = "finalize",
  Completed = "completed",
}

export enum MAINTENANCE_AUDIT_STATUS {
  NotAudited = "false",
  Audited = "true",
  Contested = "contested",
  ReplyContested = "reply_contested",
}

export type MaintenanceDocuments = {
  type: string;
  content: string;
  file?: unknown;
  verified: boolean;
};

export const emptyMaintenance = (): IMaintenance =>
({
  _id: "",
  companyId: "",
  name: "",
  renterId: "",
  vehicleId: "",
  licensePlate: "",
  waitingTicket: 0,
  mechanic: "",
  reason: "",
  chassi: "",
  model: "",
  color: "",
  whatsapp: "",
  partnerCompanyName: "",
  cpf: "",
  registers: [],
  odometer: "",
  odometerLocavibe: "",
  typeOfEvent: "",
  status: MAINTENANCE_STATUS.Pending,
  createdAt: new Date(),
  updatedAt: new Date(),
  budgetMaintenance: {
    corrective: [],
    preventive: [],
    misuse: [],
    outsourcedService: "",
  },
  observations: [],
  typePlanRenter: "",
  chargeMaintenance: {
    confirmed: false,
    charged: false,
    wasInsertedMaintenanceCharges: false,
    contested: false,
  },
  typeMaintenance: "",
  autoService: false,
  collision: false,
} as IMaintenance);

export type ProductOrServiceType = {
  corrective: Budgetlabel[];
  preventive: Budgetlabel[];
  misuse: Budgetlabel[];
};

export type budgetItem = {
  productOrWorkId: string;
  code: string;
  name: string;
  sellPrice: number;
  totalQuantity: number;
  maximumApplication: number;
  corrective: boolean;
  misuse: boolean;
  preventive: boolean;
  quantity: number;
};

export interface MaintenanceHistoryTableProps {
  licensePlate: string;
  areActionsDisabled: boolean;
  onHistoryChange: (changes: IMaintenanceHistoryItem[]) => void;
  onFullHistoryUpdate: (history: IMaintenanceHistoryItem[]) => void;
}

export type IMaintenanceHistoryItem = {
  _id: string;
  itemId: string;
  maintenanceDate: string;
  type: "corrective" | "preventive" | "misuse";
  kmAtReplacement: number;
  partReplaced: string;
  quantity: number;
  lastReplacementDate?: string;
  kmAtLastReplacement?: number;
  previousType?: string;
  newType: "corrective" | "preventive" | "misuse";
  code?: string;
  sellPrice?: number;
};

export type Budgetlabel = {
  name: string;
  code?: string;
  productOrWorkId: string;
  quantity: number;
  sellPrice: number;
  type: string;
  outsourcedService?: string;
};

export const emptyBudgetLabel = () => {
  return {
    name: "",
    productOrWorkId: "",
    quantity: 0,
    sellPrice: 0,
    code: "",
    type: "",
  };
};
